/* ####################################################################################

UO-Accessibility

Author: Sarah Becker [UO True Digital Partners]
unternehmen online GmbH & Co. KG

#################################################################################### */


class UoAccessability {
	/**
	 * Initializes UoAccessibility
	 * @returns access helpers
	 */
	
	constructor(argumentObject) {
		console.log("UO-Accessibility: Loaded");

		//All access helpers:
		this.helper = argumentObject.helper;

		//Setting hidden class for html-anchors
		this.hiddenClass = argumentObject.hiddenClass;

		//Setting focus visible styles
		this.overwriteFocusVisibleStyles = argumentObject.overwriteFocusVisibleStyles;

		//Store ariaLabels from config
		this.ariaLabels = argumentObject.ariaLabels || {};

		// Get the current language from the HTML head
		this.language = document.documentElement.lang || 'de';
		console.log(`UO-Accessibility: Language set to ${this.language}`);

		this.helper.forEach((element) => {
			console.log(`UO-Accessibility: Element ${element.helperName[this.language] || element.helperName['de-DE']} added`);
		});

		if(!this.checkDom()){
			return false;
		}

		this.addAnchors();
		console.log("UO-Accessibility: Anchors added");

		this.addAccessibilityNav();
		console.log("UO-Accessibility: Accessibility nav added");

		this.doOverwriteFocusVisibleStyles();
	}

	//Add html-anchors for all access helpers (each anchor is also an screenreader-only introductory heading)
	addAnchors() {
		this.helper.forEach((element, index) => {
			const selector = element.targetSelector;
			const target = document.querySelector(selector);

			if (!target) {
			console.warn(`[addAnchors] #${index} – target NOT found for selector: "${selector}"`);
			return;
			}

			const containerTags = ["main", "footer", "header", "aside"];

			// Take only the *very first part* of the selector (until space, >, +, ~)
			const firstPart = selector.trim().split(/[\s>+~]/)[0];

			// Extract only the tag name (remove classes, ids, attributes)
			const tagName = firstPart.match(/^[a-zA-Z]+/);
			const isContainer = tagName && containerTags.includes(tagName[0]);

			// Decide insert position
			const position = isContainer && !selector.includes(" ") && !/[>+~]/.test(selector)
			? "afterbegin"
			: "beforebegin";

			// console.groupCollapsed(`[addAnchors] #${index} selector="${selector}"`);
			// console.info("firstPart:", firstPart);
			// console.info("tagName:", tagName ? tagName[0] : "—");
			// console.info("isContainer:", isContainer);
			// console.info("position used:", position);
			// console.groupEnd();

			try {
			target.insertAdjacentHTML(
				position,
				`<span tabindex="-1" class="${this.hiddenClass}" id="${element.anchorID}">
				${element.helperName[this.language] || element.helperName['de-DE']}
				</span>`
			);
			} catch (err) {
			console.error(`[addAnchors] #${index} – insertAdjacentHTML failed for "${selector}" at "${position}"`, err);
			}
		});
	}


	//Add buttons at top of page as quick-access to all the anchors
	addAccessibilityNav() {
		//Create new div as container
		const accessibilityNav = document.createElement("nav");

		// Add aria-label for screenreader users
    	const ariaLabel = this.ariaLabels[this.language] || this.ariaLabels['de-DE'];
		accessibilityNav.setAttribute("aria-label", ariaLabel);

		//Add content and class to new div
		accessibilityNav.innerHTML = this.helper
			.map((element) => {	
				return `<a href="#${element.anchorID}" data-target="${element.anchorID}">${element.linkText[this.language] || element.linkText['de-DE']}</a>`;
			})
			.join("<br />");

		accessibilityNav.classList.add("uo-accessibility-buttons");
				
		const allLinks = accessibilityNav.querySelectorAll('a');

		console.log("allLinks: " + allLinks);

		allLinks.forEach((element) => {
			console.log("element: "+element);
			// console.log("index: "+index);

			element.addEventListener("click", (event) => {
				// event.preventDefault();
				const linkTarget = element.getAttribute("data-target");
				//console.log(linkTarget);
				document.getElementById(linkTarget).focus();

			});
		})
		
		//Insert new div at beginning of page
		const body = document.body;
		body.insertBefore(accessibilityNav, body.firstChild);
	}

	
	//Add body-class to overwrite focus-visible-styles
	doOverwriteFocusVisibleStyles() {
		if(this.overwriteFocusVisibleStyles){
			document.body.classList.add("uo-accessibility-focus");
			console.log("UO-Accessibility: Overwrite focus styles TRUE");
		} else {
			console.log("UO-Accessibility: Overwrite focus styles FALSE");
		}
	}

	/**
	 * Checks the given helpers for the existance in the dom
	 * @returns boolean depending on if all targetSelectors are found
	 */
	checkDom(){
		let checkResult = true;

		this.helper.forEach(element => {
			if(!document.querySelector(element.targetSelector)){
				checkResult = false;
				console.log(`UO-Accessibility: targetSelector ${element.targetSelector} does not exist!`);
			}
		});

		return checkResult;
	}
}

export default UoAccessability;